import * as Roles from "../constants/roles";
import layouts from "../layout";
import store from "../store/index";
import * as Routes from "./../constants/routes";

const Orders = store.state.current_community
    ? require("./../views/pages/community-context/Orders").default
    : store.state.current_corporation
    ? require("../views/pages/corporation-context/Orders").default
    : require("./../views/pages/Orders").default;
const ViewOrder = store.state.current_community
    ? require("./../views/pages/community-context/order/View").default
    : require("./../views/pages/order/View").default;
const Communities = store.state.current_corporation
    ? require("./../views/pages/corporation-context/Communities").default
    : require("./../views/pages/Communities").default;
const Users = store.state.current_corporation
    ? require("./../views/pages/corporation-context/Users").default
    : require("./../views/pages/Users").default;

export default [
    {
        path: "/",
        redirect: "/home"
    },
    {
        path: "/terms",
        name: Routes.TERMS,
        component: require("../views/pages/Terms").default
    },
    {
        path: "/home",
        name: Routes.HOME,
        component: {
            render: (c) => c("router-view")
        },
        meta: {
            auth: true,
            layout: layouts.navLeft,
            searchable: true,
            tags: ["app"],
            label: "Dashboard"
        },
        children: [
            {
                path: "cart",
                name: Routes.CART,
                component: require("../views/pages/order/ShoppingCart").default,
                meta: {
                    roles: [
                        Roles.COMMUNITY_MANAGER,
                        Roles.CORPORATION_OWNER,
                        Roles.SUPER_ADMIN,
                        Roles.ADMIN,
                        Roles.EMPLOYEE,
                        Roles.ACCOUNTANT
                    ],
                    label: "Shopping Cart"
                }
            },
            {
                path: "checkout",
                name: Routes.CHECKOUT,
                component: require("../views/pages/order/Checkout").default,
                meta: {
                    roles: [
                        Roles.COMMUNITY_MANAGER,
                        Roles.CORPORATION_OWNER,
                        Roles.SUPER_ADMIN,
                        Roles.ADMIN,
                        Roles.EMPLOYEE,
                        Roles.ACCOUNTANT
                    ],
                    label: "Checkout"
                }
            },
            {
                path: "settings/account",
                name: Routes.ACCOUNT_DETAILS,
                component: require("../views/pages/settings/Account").default,
                label: "Settings",
                meta: {
                    label: "My Account"
                }
            },
            {
                path: "calendars/create",
                name: Routes.CREATE_CALENDAR,
                component: require("../views/pages/calendar/Create").default,
                label: "Edit Calendar",
                meta: {
                    roles: [
                        Roles.COMMUNITY_MANAGER,
                        Roles.CORPORATION_OWNER,
                        Roles.SUPER_ADMIN,
                        Roles.ADMIN,
                        Roles.EMPLOYEE
                    ],
                    label: "Edit Calendar"
                }
            },
            {
                path: "calendars/:id/edit",
                name: Routes.EDIT_CALENDAR,
                component: require("../views/pages/calendar/Edit").default,
                label: "Edit",
                meta: {
                    roles: [
                        Roles.COMMUNITY_MANAGER,
                        Roles.CORPORATION_OWNER,
                        Roles.SUPER_ADMIN,
                        Roles.ADMIN,
                        Roles.EMPLOYEE
                    ],
                    label: "Edit Calendar"
                }
            },
            {
                path: "newsletters/:id/edit",
                name: Routes.EDIT_NEWSLETTER,
                component: require("../views/pages/newsletter/Edit").default,
                label: "Edit Newsletter",
                meta: {
                    roles: [
                        Roles.COMMUNITY_MANAGER,
                        Roles.CORPORATION_OWNER,
                        Roles.SUPER_ADMIN,
                        Roles.ADMIN,
                        Roles.EMPLOYEE
                    ],
                    label: "Edit Newsletter"
                }
            },
            {
                path: "dashboard",
                name: Routes.DASHBOARD,
                component: require("../views/pages/community-context/Dashboard")
                    .default,
                meta: {
                    roles: [
                        Roles.COMMUNITY_MANAGER,
                        Roles.CORPORATION_OWNER,
                        Roles.COMMUNITY_ACCOUNTANT,
                        Roles.SUPER_ADMIN,
                        Roles.ADMIN,
                        Roles.EMPLOYEE,
                        Roles.ACCOUNTANT
                    ],
                    label: "Dashboard"
                }
            },
            {
                path: "orders",
                name: Routes.ORDERS,
                component: Orders,
                meta: {
                    label: "Order History",
                    roles: [
                        Roles.COMMUNITY_MANAGER,
                        Roles.CORPORATION_OWNER,
                        Roles.COMMUNITY_ACCOUNTANT,
                        Roles.SUPER_ADMIN,
                        Roles.ADMIN,
                        Roles.EMPLOYEE,
                        Roles.ACCOUNTANT
                    ]
                }
            },
            {
                path: "proofs",
                name: Routes.NEWS_PROOFS,
                component:
                    require("../views/pages/community-context/NewsProofs")
                        .default,
                meta: {
                    label: "News Proofs",
                    roles: [
                        Roles.COMMUNITY_MANAGER,
                        Roles.CORPORATION_OWNER,
                        Roles.SUPER_ADMIN,
                        Roles.ADMIN,
                        Roles.EMPLOYEE
                    ]
                }
            },
            {
                path: "digital-display",
                name: Routes.DIGITAL_DISPLAY,
                component:
                    require("../views/pages/community-context/DigitalDisplay")
                        .default,
                meta: {
                    label: "Digital Display"
                }
            },
            {
                path: "orders/dashboard",
                name: Routes.ORDER_DASHBOARD,
                component: require("../views/pages/order/Dashboard").default,
                meta: {
                    roles: [
                        Roles.SUPER_ADMIN,
                        Roles.ADMIN,
                        Roles.EMPLOYEE,
                        Roles.ACCOUNTANT
                    ],
                    label: "Order Dashboard"
                }
            },
            {
                path: "orders/pending",
                name: Routes.PENDING_ORDERS,
                component: require("../views/pages/order/Pending").default,
                meta: {
                    roles: [
                        Roles.SUPER_ADMIN,
                        Roles.ADMIN,
                        Roles.EMPLOYEE,
                        Roles.ACCOUNTANT
                    ],
                    label: "Pending Orders"
                }
            },
            {
                path: "orders/hub",
                name: Routes.ORDER_HUB,
                component: require("../views/pages/order/Hub").default,
                meta: {
                    roles: [
                        Roles.SUPER_ADMIN,
                        Roles.ADMIN,
                        Roles.EMPLOYEE,
                        Roles.ACCOUNTANT
                    ],
                    label: "Order Hub"
                }
            },
            {
                path: "orders/closed",
                name: Routes.CLOSED_ORDERS,
                component: require("../views/pages/order/Closed").default,
                meta: {
                    roles: [
                        Roles.SUPER_ADMIN,
                        Roles.ADMIN,
                        Roles.EMPLOYEE,
                        Roles.ACCOUNTANT
                    ],
                    label: "Closed Orders"
                }
            },
            {
                path: "orders/:id",
                name: Routes.VIEW_ORDER,
                component: ViewOrder,
                meta: {
                    roles: [
                        Roles.COMMUNITY_MANAGER,
                        Roles.CORPORATION_OWNER,
                        Roles.COMMUNITY_ACCOUNTANT,
                        Roles.SUPER_ADMIN,
                        Roles.ADMIN,
                        Roles.EMPLOYEE,
                        Roles.ACCOUNTANT
                    ],
                    label: "View Order"
                }
            },
            {
                path: "orders/:id/edit",
                name: Routes.EDIT_ORDER,
                component: require("../views/pages/order/Edit").default,
                meta: {
                    roles: [
                        Roles.SUPER_ADMIN,
                        Roles.ADMIN,
                        Roles.EMPLOYEE,
                        Roles.ACCOUNTANT
                    ],
                    label: "Edit Order"
                }
            },
            {
                path: "orders/:id/edit-status",
                name: Routes.EDIT_ORDER_STATUS,
                component: require("../views/pages/order/EditStatus").default,
                meta: {
                    roles: [
                        Roles.SUPER_ADMIN,
                        Roles.ADMIN,
                        Roles.EMPLOYEE,
                        Roles.ACCOUNTANT
                    ],
                    label: "Edit Order Status"
                }
            },
            {
                path: "orders/:id/edit-invoice-lines",
                name: Routes.EDIT_ORDER_INVOICE_LINES,
                component: require("../views/pages/order/EditInvoiceLines")
                    .default,
                meta: {
                    roles: [Roles.SUPER_ADMIN, Roles.ACCOUNTANT],
                    label: "Edit Order Confirmation Custom Lines"
                }
            },
            {
                path: "announcements",
                name: Routes.ANNOUNCEMENTS,
                component:
                    require("../views/pages/corporation-context/Announcements")
                        .default,
                meta: {
                    roles: [Roles.CORPORATION_OWNER, Roles.SUPER_ADMIN],
                    label: "Announcements"
                }
            },
            {
                path: "filler-articles",
                name: Routes.FILLER_ARTICLES,
                component: require("../views/pages/FillerArticles").default,
                label: "Filler Articles",
                meta: {
                    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.EMPLOYEE],
                    label: "Filler Articles"
                }
            },
            {
                path: "communities",
                name: Routes.COMMUNITIES,
                component: Communities,
                meta: {
                    roles: [
                        Roles.SUPER_ADMIN,
                        Roles.ADMIN,
                        Roles.EMPLOYEE,
                        Roles.ACCOUNTANT,
                        Roles.CORPORATION_OWNER
                    ],
                    label: "Communities"
                }
            },
            {
                path: "corporations",
                name: Routes.CORPORATIONS,
                component: require("../views/pages/Corporations").default,
                meta: {
                    roles: [
                        Roles.SUPER_ADMIN,
                        Roles.ADMIN,
                        Roles.EMPLOYEE,
                        Roles.ACCOUNTANT
                    ],
                    label: "Corporations"
                }
            },
            {
                path: "communities/create",
                name: Routes.CREATE_COMMUNITY,
                component: require("../views/pages/community/Create").default,
                meta: {
                    roles: [Roles.SUPER_ADMIN],
                    label: "Create Community"
                }
            },
            {
                path: "communities/:id/edit",
                name: Routes.EDIT_COMMUNITY,
                component: () =>
                    import(
                        /* webpackChunkName: "community-edit" */ "../views/pages/community/Edit"
                    ),
                meta: {
                    roles: [
                        Roles.SUPER_ADMIN,
                        Roles.ADMIN,
                        Roles.EMPLOYEE,
                        Roles.ACCOUNTANT
                    ],
                    label: "Edit Community"
                }
            },
            {
                path: "communities/:id/logs",
                name: Routes.COMMUNITY_LOGS,
                component: require("../views/pages/community/Logs").default,
                meta: {
                    roles: [Roles.SUPER_ADMIN],
                    label: "Community Logs"
                }
            },
            {
                path: "users",
                name: Routes.USERS,
                component: Users,
                meta: {
                    roles: [Roles.SUPER_ADMIN, Roles.ADMIN],
                    label: "Users"
                }
            },
            {
                path: "themes",
                name: Routes.THEMES,
                component: require("../views/pages/Themes").default,
                meta: {
                    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.EMPLOYEE],
                    label: "Calendar Themes"
                }
            },
            {
                path: "settings/pricing",
                name: Routes.PRICING,
                component: require("../views/pages/Pricing").default,
                meta: {
                    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ACCOUNTANT],
                    label: "Pricing"
                }
            },
            {
                path: "settings/shipping",
                name: Routes.SETTINGS,
                component: require("../views/pages/Settings").default,
                label: "Settings",
                meta: {
                    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ACCOUNTANT],
                    label: "Shipping"
                }
            },
            {
                path: "settings/early-bird",
                name: Routes.EARLY_BIRD,
                component: require("../views/pages/settings/EarlyBird").default,
                label: "Early Bird Deadlines",
                meta: {
                    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ACCOUNTANT],
                    label: "Early Bird"
                }
            },
            {
                path: "settings/notification",
                name: Routes.NOTIFICATION_SETTINGS,
                component: require("../views/pages/settings/Notifications")
                    .default,
                label: "Notifications",
                meta: {
                    roles: [Roles.SUPER_ADMIN, Roles.ADMIN],
                    label: "Notifications"
                }
            },
            {
                path: "settings/holiday",
                name: Routes.HOLIDAY,
                component: require("../views/pages/settings/Holiday").default,
                label: "Holidays",
                meta: {
                    roles: [Roles.SUPER_ADMIN, Roles.ADMIN],
                    label: "Holidays"
                }
            },
            {
                path: "settings/event-logs",
                name: Routes.EVENT_LOGS,
                component: require("../views/pages/settings/EventLogs").default,
                label: "Event Logs",
                meta: {
                    roles: [
                        Roles.COMMUNITY_MANAGER,
                        Roles.CORPORATION_OWNER,
                        Roles.SUPER_ADMIN,
                        Roles.ADMIN,
                        Roles.EMPLOYEE
                    ],
                    label: "Event Logs"
                }
            },
            {
                path: "corporations/create",
                name: Routes.CREATE_CORPORATION,
                component: require("../views/pages/corporation/Create").default,
                label: "Create Corporation",
                meta: {
                    roles: [Roles.SUPER_ADMIN],
                    label: "Create Corporation"
                }
            },
            {
                path: "corporations/:id/edit",
                name: Routes.EDIT_CORPORATION,
                component: require("../views/pages/corporation/Edit").default,
                label: "Edit Corporation",
                meta: {
                    roles: [Roles.SUPER_ADMIN],
                    label: "Edit Corporation"
                }
            },
            {
                path: "filler-articles/create",
                name: Routes.CREATE_FILLER_ARTICLE,
                component: require("../views/pages/filler-article/Create")
                    .default,
                meta: {
                    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.EMPLOYEE],
                    label: "Create Filler Article"
                }
            },
            {
                path: "filler-articles/:id/edit",
                name: Routes.EDIT_FILLER_ARTICLE,
                component: require("../views/pages/filler-article/Edit")
                    .default,
                meta: {
                    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.EMPLOYEE],
                    label: "Edit Filler Article"
                }
            },
            {
                path: "sage",
                name: Routes.SAGE,
                component: require("../views/pages/Sage").default,
                meta: {
                    label: "Sage Settings",
                    roles: [Roles.SUPER_ADMIN, Roles.ACCOUNTANT]
                }
            }
        ]
    },
    {
        path: "/backend",
        component: {
            render: (c) => c("router-view")
        },
        meta: {
            admin: true,
            layout: layouts.navLeft,
            tags: ["app"]
        }
    },
    {
        path: "/password/forgot",
        name: Routes.FORGOT_PASSWORD,
        component: require("../views/pages/authentication/ForgotPassword")
            .default,
        meta: {
            layout: layouts.contentOnly,
            guest: true,
            label: "Forgot Password"
        }
    },
    {
        path: "/password/reset/:token",
        name: Routes.RESET_PASSWORD,
        component: require("../views/pages/authentication/ResetPassword")
            .default,
        meta: {
            layout: layouts.contentOnly,
            guest: true,
            label: "Reset Password"
        }
    },
    {
        path: "/login",
        name: Routes.LOGIN,
        component: require("../views/pages/authentication/Login").default,
        meta: {
            layout: layouts.contentOnly,
            label: "Login"
        }
    },
    {
        path: "/register",
        name: Routes.REGISTER,
        component: require("../views/pages/authentication/Register").default,
        meta: {
            layout: layouts.contentOnly
        }
    },
    {
        path: "/suspended",
        name: Routes.SUSPENDED,
        component: require("../views/pages/community-context/Suspended")
            .default,
        meta: {
            layout: layouts.contentOnly,
            label: "Suspended"
        }
    },
    {
        path: "/dd/:code",
        name: Routes.DIGITAL_DISPLAY_URL,
        component: require("../views/pages/community-context/DigitalDisplayUrl")
            .default,
        meta: {
            layout: layouts.contentOnly,
            label: "Digital Display"
        }
    },
    {
        path: "/access-denied",
        name: Routes.ACCESS_DENIED,
        component: require("../views/pages/AccessDenied").default,
        meta: {
            auth: true,
            layout: layouts.contentOnly,
            label: "Access Denied"
        }
    }
];
